import { ICON_VIEW_BOX, ICONS, type IconName } from './icons';
import { toneOf, type IconTone } from './tones';

/**
 * Значок Material Symbols.
 *
 * Иконки проксируются через дизайн-систему: замена набора позже не тронет ни одного
 * экрана — docs/DESIGN.md, «Иконки». Размер по умолчанию 24: столько в панелях
 * и навигации; в строках списков ставится 22 явно.
 *
 * `FILL 1` — только у активного пункта навигации и у отмеченного избранного: это
 * единственный способ, которым иконка меняет вес.
 *
 * **Цвет значок берёт по смыслу** ([tones.ts](tones.ts)), а не от места, где стоит:
 * дело синее и в списке, и в карточке, и в поиске. Там, где цвет задаёт сам компонент
 * — плитка типа, активный пункт навигации, опасное действие в листе, — правило
 * компонента побеждает по весу селектора.
 */
export function Icon({
  name,
  size = 24,
  filled = false,
  className,
  tone,
}: {
  name: IconName;
  size?: number;
  filled?: boolean;
  className?: string;
  /** Тон в обход таблицы — когда значок стоит не за свою сущность. */
  tone?: IconTone;
}) {
  const key = (filled ? `${name}_fill` : name) as IconName;
  const path = ICONS[key] ?? ICONS[name];

  return (
    <svg
      className={`icon icon--${tone ?? toneOf(name)} ${className ?? ''}`}
      width={size}
      height={size}
      viewBox={ICON_VIEW_BOX}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d={path} />
    </svg>
  );
}

export type { IconName };
